import {
  Dialog
} from "vx-mobile";
const dict = {//自定义报错内容
  zh_CN: {
    messages: {
      required: function (field) {
        return "请输入" + field;
      },
    }
  }
};
export default function (thisform, nameList) {
  var that = thisform;
  if (nameList.some(function (item, index) {
      if (that.$validator.errors.has(item)) {
        Dialog.alert({
          title: "提示",
          content: that.$validator.errors.first(item),
          confirmText: "确定",
          onConfirm: () => console.log("[Dialog.alert] confirm clicked")
        });
        return true;
      };
    })) {
    return true;
  }
}
export var dictionary = dict;



// WEBPACK FOOTER //
// ./src/modules/utils/validator.js